import { useState } from "react";
import "../../assets/css/plan-page.css";
import { planData } from "../../assets/json/plan";
import PlanCriteria from "./PlanCriteria";

const ComparePlan = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleCollapse = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="plan-table">
            <table className="table table-bordered mt-5">
              <tbody className="text-center">
                <tr className="desktop-th">
                  <th scope="col" colSpan={2}>Features</th>
                  <th scope="col">Free</th>
                  <th scope="col">Standard</th>
                  <th scope="col">Enterprise</th>
                </tr>
                {planData.map((item, index) => (

                  <>
                    {/* <h5 className="text-primary fs-20 fw-600 mb-4 mt-4 text-start">
                  {item.criteria}
                </h5> */}
                    <tr onClick={() => toggleCollapse(index)} style={{ cursor: "pointer" }}>
                      <td data-label="" className="text-primary text-start" colSpan={2}>
                        {item.criteria}

                      </td>
                      <td data-label="Free">
                        {item.dataType === "string" ? (
                          item.free
                        ) : item.free === "yes" ? (
                          <img
                            src={require("../../assets/images/comp/tick-circle.png")}
                            alt="error"
                          />
                        ) : "" ? (
                          ""
                        ) : (
                          ""
                        )}
                      </td>
               
                      <td data-label="premium">
                        {item.dataType === "string" ? (
                          item.premium
                        ) : item.premium === "yes" ? (
                          <img
                            src={require("../../assets/images/comp/tick-circle.png")}
                            alt="error"
                          />
                        ) : "" ? (
                          ""
                        ) : (
                          ""
                        )}
                      </td>
                      <td data-label="enterprise" className="position-relative">
                        {item.dataType === "string" ? (
                          item.enterprise
                        ) : item.enterprise === "yes" ? (
                          <>
                            <img
                              src={require("../../assets/images/comp/tick-circle.png")}
                              alt="error"
                            />
                            <span className="table-floating-arrow">
                              <svg className={`${openIndex === index ? 'table-arrows-rotate-down' : 'table-arrows-rotate-up'}`} width="30" height="30" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="18" cy="18" r="18"  fill={openIndex === index ? '#117FEA':'#F2F9FF' } />
                                <path d="M13.2441 19.0776L14.4225 20.2559L18 16.6784L21.5775 20.2559L22.7558 19.0776L18 14.3218L13.2441 19.0776Z"  fill={openIndex === index ? 'white':'gray' }  />
                              </svg>


                            </span>
                          </>
                        ) : "" ? (
                          ""
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                    {openIndex === index && (
                      <PlanCriteria data={item} />
                    )}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparePlan;



